import * as axios from 'axios';
import qs from 'qs';


function compactInspectDatabase(uid) { 

    const data = {  }

    const url = `/inspect/compact/${uid}`;
    return axios.get(url, data)
        // get data
        .then(x => x.data)
        // add url field
        .then(x => {
            if (x.status == 'error') {
                return Promise.reject(x);
            }
            return x
        });
}


export { compactInspectDatabase }